export enum ContentGeneratorRouteParam {
  TACTIC = 'funnelTacticId',
  ACTIVITY = 'activityId',
  ASSET = 'assetId',
}
